module.exports = __webpack_public_path__ + "img/product-02-olive.ce7c9d46.jpg";